module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/菌落仪图片英文.eff0ac8d.png";